import Vue from 'vue'
import Element from 'element-ui'
import { PopupManager } from 'element-ui/lib/utils/popup'
import { initPopupManager } from '@mypaas/honeycomb-ui/lib/utils/popup'
import initToast from '@common/utils/initToastMessage'
import commonComponents from '@common/components'
import Honeycomb from '@mypaas/honeycomb-ui'
import PaasSdk from '@mypaas/app-render-engine/src/sdk'
import router from '@studio/router'
import store from '@store'
import { parseQuery } from '@common/utils/query'
import '@common/style/index.less'
import '@common/assets/less/element.less'
import '@common/assets/less/iconfont.less'
import 'console-theme-default/lib/index.css'
import '@mypaas/honeycomb-ui/lib/theme-honeycomb/index.css'
import '@common/assets/less/console.less'
import DesignComponent from '@mypaas/design-components'
import '@mypaas/design-components/lib/design-components.css'
import { themePlugin, designPlugin } from '@mypaas/app-render-engine/core/sdk'

import hackDesignComponent from '@common/utils/lazyRenderWrapper'
import { bus } from '@utils/event'
import To from '@common/utils/await-to'
// import devtool from '@common/utils/devtool'
import App from './app'
import '@common/icons'

const query = parseQuery(window.location.search)
// let devtoolsEnable = false

// 调试本地组件，开启 devtools
if (query.dev === 'component') {
    // devtoolsEnable = true
    Vue.config.devtools = true
    // Vue.use(devtool)
}

hackDesignComponent(DesignComponent)

PaasSdk.native.init()

initPopupManager(PopupManager)
Vue.use(To)
Vue.use(Element)
Vue.use(Honeycomb)
Vue.use(DesignComponent)
Vue.use(commonComponents)
Vue.use(themePlugin)
Vue.use(designPlugin)
Vue.config.productionTip = false

bus.$on('404', () => router.replace('/404.html'))
bus.$on('401', () => router.replace('/401.html'))
bus.$on('503', data => {
    window.sessionStorage.setItem('message-503', data.msg)
    router.replace('/503.html')
})

initToast(Vue)

const main = new Vue({
    router,
    store,
    render: h => h(App),
    // devtoolsEnable,
})

main.$mount('#app')
